export const methods = ["Text", "Email", "Print"]
export const methodsText: any = {
    "Text": "Text",
    "Email": "Email",
    "Print": "Print at home"
}
